import { filterableContentOf } from "../../utils/filterableContentOf";
import { multilingualArrayString } from "./index";

export default filterableContentOf(
  multilingualArrayString.name,
  multilingualArrayString.toReadableText!,
  "filterableMultilingualString"
);
